module.exports = __webpack_public_path__ + "img/profile_image.310eea5d.svg";